<template>
    <div id="wrapper" class="font-fira">
      <TextHeader headerTitle="Sound" />
      <div id="content" class="w-container">
        <p class="section-heading mt-0">1. <span v-html="$t('sound.heading1')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p1')" />
        <img src="https://madrigal-public.s3.eu-central-1.amazonaws.com/artsafari2023/sound/01.jpg" alt="The Madrigal Choir Art Safari Gallery"/>
        <p class="section-heading">2. <span v-html="$t('sound.heading2')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p2')" />
        <p class="section-heading">3. <span v-html="$t('sound.heading3')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p3')" />
        <p class="section-heading">4. <span v-html="$t('sound.heading4')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p4')" />
        <p v-html="$t('sound.p5')" />
        <p>Monica Lup, jurnalist</p>
        <img src="https://madrigal-public.s3.eu-central-1.amazonaws.com/artsafari2023/sound/02.jpg" alt="The Madrigal Choir Art Safari Gallery"/>
        <p class="section-heading">5. <span v-html="$t('sound.heading5')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p6')" />
        <p v-html="$t('sound.p7')" />
        <p v-html="$t('sound.p8')" />
        <p>Monica Lup, jurnalist</p>
        <p class="section-heading">6. <span v-html="$t('sound.heading6')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p9')" />
        <p class="section-heading">7. <span v-html="$t('sound.heading7')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p10')" />
        <img src="https://madrigal-public.s3.eu-central-1.amazonaws.com/artsafari2023/sound/04.jpg" alt="The Madrigal Choir Art Safari Gallery"/>
        <p class="section-heading">8. <span v-html="$t('sound.heading8')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p11')" />
        <p class="section-heading">9. <span v-html="$t('sound.heading9')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p12')" />
        <p v-html="$t('sound.p13')" />
        <p v-html="$t('sound.p14')" />
        <img src="https://madrigal-public.s3.eu-central-1.amazonaws.com/artsafari2023/sound/03.jpg" alt="The Madrigal Choir Art Safari Gallery"/>
        <p class="section-heading">10. <span v-html="$t('sound.heading10')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p15')" />
        <p class="section-heading">11. <span v-html="$t('sound.heading11')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p16')" />
        <p v-html="$t('sound.p17')" />
        <p class="section-heading">12. <span v-html="$t('sound.heading12')" /></p>
        <div class="underline-bar" />
        <p v-html="$t('sound.p18')" />
      </div>
    </div>
  </template>
<script>
  import TextHeader from "./TextHeader";
  export default {
    name: "Sound",
    components: { TextHeader },
    data() {}
  }
</script>
<style style scoped lang="scss">
  #content {
    font-family: Fira Sans,sans-serif;
    font-size: 1.3em;
    line-height: 25px;
    font-weight: 400;
    padding: 60px 0;
  }

  @media screen and (max-width: 1155px) {
    #content {
      padding: 60px 7px;
    }
  }

  .section-heading {
    font-size: 1.4em;
    line-height: 45px;
    margin-top: 30px;
    font-weight: bold;
  }

  .underline-bar {
    background-color: #333;
    height: 3px;
    width: 120px;
    margin-bottom: 20px;
  }
</style>